import { Color } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line
    export namespace Color {
        let parseHEX: (hex: string) => Color;
    }
}

Color.parseHEX = function parseHEX(hex: string): Color {
    const color = new Color();
    color.fromHEX(hex);
    return color;
};
